export default __webpack_public_path__ + "static/ai-solutions-with-roadmap1--mobile-d883a116024ee8ba2d8092941ef6dde0.webp";